/**
 * API layer người dùng được quản lý — danh sách và cập nhật user thường.
 */
import { apiClient } from '../../../../shared/services/apiClient';
import { API_ROUTES } from '../../../../shared/constants/apiRoutes';

/** Các hàm gọi API managed users. */
export const managedUserApi = {
  /** Danh sách user do admin quản lý. */
  getManagedUsers: () => apiClient.get(API_ROUTES.adminManagedUsers),
  /** Cập nhật thông tin/trạng thái user. */
  updateManagedUser: (userId, payload) => apiClient.put(API_ROUTES.adminManagedUser(userId), payload),
};
